export default {
  BRANCHES: (state) => state.branches,
};
